export default "<div ng-show=\"commandEnabled\">\n    When Set Position is selected, click anywhere in the map to set a V-tag gateway there.\n</div>\n";